module.exports = __webpack_public_path__ + "static/media/bungalowvip1.430a98be.jpg";